import React from 'react';

const A4Table = ({ type, dates }) => {
  // console.log(dates);
  const months = [];
  dates.map(date => months.push(date.toLocaleString('gb', { month: 'short' })));
  console.log(months);
  const styleObj =  {
    'center': {
      'display': 'flex',
      'flexDirection': 'column',
      'alignItems': 'center',
    },
    'spacing': {
      'display': 'flex',
      'width': '100%',
      'textAlign': 'center',
      'justifyContent': 'space-around'
    }
  }
  return type === "front" ? ( 
    <div className="a4-table">
     <div className="rotate" style={styleObj.center}>
       <div style={styleObj.spacing}>
         <p>Goals</p>
         <p>Goals</p>
         <p>Goals</p>
       </div>
       <div style={styleObj.spacing}>
        <p>{months[3]}</p>
        <p>{months[4]}</p>
        <p>{months[5]}</p>
       </div>
      </div>
      <div style={styleObj.center}>
        <div style={styleObj.spacing}>
          <p>Goals</p>
          <p>Goals</p>
          <p>Goals</p>
        </div>
        <div style={styleObj.spacing}>
          <p>{months[0]}</p>
          <p>{months[1]}</p>
          <p>{months[2]}</p>
        </div>
      </div>
    </div>
   ) : (
    <div className="a4-table">
    <div className="rotate" style={styleObj.center}>
      <div style={styleObj.spacing}>
        <p>Goals</p>
        <p>Goals</p>
        <p>Goals</p>
      </div>
      <div style={styleObj.spacing}>
       <p>{months[9]}</p>
       <p>{months[10]}</p>
       <p>{months[11]}</p>
      </div>
     </div>
     <div style={styleObj.center}>
       <div style={styleObj.spacing}>
         <p>Goals</p>
         <p>Goals</p>
         <p>Goals</p>
       </div>
       <div style={styleObj.spacing}>
         <p>{months[6]}</p>
         <p>{months[7]}</p>
         <p>{months[8]}</p>
       </div>
     </div>
   </div>
   );
}
 
export default A4Table;